// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CartItemAmount-CancelButton-title{font-size:1.4375rem;font-weight:900;margin-bottom:1.25rem;margin-top:.875rem}.CartItemAmount-CancelButton{border:1px solid #7cb342;border-radius:.25rem;color:#606060;font-size:.9375rem;padding-bottom:.625rem;padding-top:.625rem}.CartItemAmount-CancelButton:hover{color:#7cb342}.CartItemAmount-RemoveButton{font-size:.9375rem;margin-top:.5rem!important;padding-bottom:.625rem;padding-top:.625rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
